import * as Sentry from '@sentry/browser'
import { ENVIRONMENT } from "../common/constants"

export const captureException = error => {
  if (error.response && error.response.status) {
    /* Exclude sending sentry data conflict errors that the user needs to resolve */
    if (error.response.status !== 409) {
      Sentry.captureMessage(error.response.data.msg, error.response.status)
    }
  } else {
    if (error && ENVIRONMENT !== 'local') {
      Sentry.captureException(error)
    } else {
      console.error(error)
    }
  }
}

export const setUserContext = email => {
  Sentry.configureScope((scope) => {
    scope.setUser({
      email: email
    })
  })
}


// WEBPACK FOOTER //
// ./assets/common/error.js